<div class="d-flex flex-column h-100" style="background-color: #ffffff !important">
  <div class="card border-0 shadow-none ocultar" style="position: fixed; width: 100%; height: 65px">
    <div class="card">
      <div class="card-header bg-white border-bottom py-2">
        <div class="d-flex justify-content-between align-items-center">
          <span *ngIf="euSou === 'colaborador'" class="badge bg-info round me-2">Olá, Colaborador</span>
          <span *ngIf="euSou === 'beneficiario'" class="badge bg-info round me-2">Olá, Beneficiário</span>
          <h3 class="card-title mb-0">
            <i class="fas fa-file-alt me-2"></i>
            Visualização de Documento
          </h3>
          <div class="d-flex">
            <button class="btn btn-success shadow-6 bold text-white round btn-md me-2" (click)="imprimir()">
              <i class="fa fa-print me-1"></i>
              Imprimir
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div id="section-visualizar" style="margin-top: 70px" class="flex-grow-1 overflow-auto p-0">
    <!-- SAUDE -->
    <!-- UDEMO -->
    <ng-container *ngIf="!heOdonto">
      <ng-container *ngIf="entidades.heUdemo">
        <app-proposta-documento-final-udemo
          [dadosOperadoraDM]="dadosOperadoraDM"
          [idProposta]="idProposta"
          [listaBeneficiarioDSSelecionados]="listaBeneficiarioDSSelecionados"
          class="h-100"></app-proposta-documento-final-udemo>
      </ng-container>

      <!-- UNIMED FESP -->
      <ng-container *ngIf="entidades.heUnimedFesp">
        <app-documento-unimed-fesp-proposta
          [dadosOperadoraDM]="dadosOperadoraDM"
          [idProposta]="idProposta"
          [listaBeneficiarioDSSelecionados]="listaBeneficiarioDSSelecionados"
          class="h-100"></app-documento-unimed-fesp-proposta>
      </ng-container>
    </ng-container>

    <!-- odonto -->
    <ng-container *ngIf="heOdonto">
      <ng-container *ngIf="entidades.heUniOdonto">
        <app-documentos-proposta-externa-uniodonto
          [dadosOperadoraDM]="dadosOperadoraDM"
          [heOdonto]="heOdonto"
          [idProposta]="idProposta"></app-documentos-proposta-externa-uniodonto>
      </ng-container>

      <ng-container *ngIf="entidades.heUnimedOdonto">
        <app-documentos-proposta-externa-unimedOdonto
          [dadosOperadoraDM]="dadosOperadoraDM"
          [heOdonto]="heOdonto"
          [idProposta]="idProposta"></app-documentos-proposta-externa-unimedOdonto>
      </ng-container>

      <ng-container *ngIf="entidades.heOdontoPrev">
        <app-documentos-proposta-externa-OdontoPrev
          [dadosOperadoraDM]="dadosOperadoraDM"
          [heOdonto]="heOdonto"
          [idProposta]="idProposta"></app-documentos-proposta-externa-OdontoPrev>
      </ng-container>
    </ng-container>
  </div>
</div>
